import { render, staticRenderFns } from "./userBlacklist.vue?vue&type=template&id=00ead5e9&scoped=true"
import script from "./userBlacklist.vue?vue&type=script&lang=js"
export * from "./userBlacklist.vue?vue&type=script&lang=js"
import style0 from "./userBlacklist.vue?vue&type=style&index=0&id=00ead5e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ead5e9",
  null
  
)

export default component.exports